module.exports = __webpack_public_path__ + "static/media/destaque.189f8f7e.png";